export default "__VITE_ASSET__BIjK7BUN__"